import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { useRef, useEffect } from "react";
import { useSearchParams } from "react-router";

interface LeadsSearchHeaderProps {
    className?: string;
}

const LeadsSearchHeader: React.FC<LeadsSearchHeaderProps> = ({ className }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        if (searchParams.get("search") && formRef.current) {
            formRef.current.search.value = searchParams.get("search") || "";
        }
    }, [searchParams]);

    const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.target as HTMLFormElement;
        const searchValue = form.search.value.trim();

        const params: Record<string, string> = {
            page: "1",
            per_page: "10",
        };

        if (searchValue) {
            params.search = searchValue;
        }

        setSearchParams(params);
    };

    const clearSearch = () => {
        const params: Record<string, string> = {
            page: "1",
            per_page: "10",
        };
        setSearchParams(params);
        if (formRef.current) {
            formRef.current.search.value = "";
        }
    };

    const hasSearch = searchParams.get("search");

    return (
        <div className={className}>
            <div className="flex justify-end">
                <div className="flex gap-2 items-center">
                    <form ref={formRef} className="flex border rounded-md" onSubmit={handleSearchSubmit}>
                        <Input placeholder="Search leads..." className="border-none" name="search" />
                        <Button variant={"ghost"} type="submit">
                            <Search />
                        </Button>
                    </form>

                    {hasSearch && <Button onClick={clearSearch}>Clear</Button>}
                </div>
            </div>
        </div>
    );
};

export default LeadsSearchHeader;
